import Vue from 'vue';
import VueSession from 'vue-session';
import JsonExcel from 'vue-json-excel';
import VuetifyDialog from 'vuetify-dialog';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'vuetify-dialog/dist/vuetify-dialog.css';
import 'babel-polyfill';

const options = {
  persist: true,
};
Vue.component('downloadExcel', JsonExcel);
Vue.use(VueSession, options);
Vue.use(VuetifyDialog);
Vue.use(require('vue-moment'));

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app');
